import styled from "@emotion/native";
import * as drawer from "../../utils/drawer";
import Text from "../../components/Text";

export const Container = styled.View({
	flex: 1,
	paddingHorizontal: 12,
});

export const Scroll = styled.ScrollView({
	marginTop: drawer.BUTTON_TOP + drawer.BUTTON_HEIGHT + 18,
	overflow: "visible",
});

export const Header = styled.View({
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	marginBottom: 32,
});

export const Title = styled(Text)({
	maxWidth: "70%",
});

export const Caption = styled(Text)({});

export const Resources = styled.View({});
